export default function WhyGovernmentWontWork() {
  return (
    <section className="py-14 md:py-20 bg-[#F7F7F5]">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-4xl font-bold text-[#2D2D2D] mb-4">
            Why Standard Processing Won't Solve Your Urgent Situation
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {/* Card 1 */}
          <div className="bg-white rounded-lg border border-gray-200 p-6 md:p-8 flex flex-col items-center text-center">
            <div className="w-16 h-16 flex items-center justify-center bg-amber-100 rounded-full mb-5">
              <i className="ri-timer-line text-amber-600 text-2xl"></i>
            </div>
            <h3 className="text-lg font-bold text-[#2D2D2D] mb-3">Government Timeline Is Too Slow</h3>
            <p className="text-gray-600 text-sm leading-relaxed">
              Routine processing: 4–6 weeks. Government expedited (the $60 fee): 2–3 weeks. Neither includes mailing time, which adds another 1–2 weeks each way. If your trip is within 4–8 weeks, the government route alone simply won't get you there.
            </p>
          </div>

          {/* Card 2 */}
          <div className="bg-white rounded-lg border border-gray-200 p-6 md:p-8 flex flex-col items-center text-center">
            <div className="w-16 h-16 flex items-center justify-center bg-amber-100 rounded-full mb-5">
              <i className="ri-calendar-close-line text-amber-600 text-2xl"></i>
            </div>
            <h3 className="text-lg font-bold text-[#2D2D2D] mb-3">Passport Agency Appointments Are Booked</h3>
            <p className="text-gray-600 text-sm leading-relaxed">
              Regional passport agencies handle urgent cases by appointment only. In 2026, with over 27 million passports issued, those appointments book 2–4 weeks in advance. You cannot walk in. For most urgent situations, waiting for an appointment isn't an option.
            </p>
          </div>

          {/* Card 3 */}
          <div className="bg-white rounded-lg border border-gray-200 p-6 md:p-8 flex flex-col items-center text-center">
            <div className="w-16 h-16 flex items-center justify-center bg-amber-100 rounded-full mb-5">
              <i className="ri-mail-close-line text-amber-600 text-2xl"></i>
            </div>
            <h3 className="text-lg font-bold text-[#2D2D2D] mb-3">Post Office Can't Speed It Up</h3>
            <p className="text-gray-600 text-sm leading-relaxed">
              Your local post office or passport acceptance facility can submit your application — but they have no ability to expedite processing or jump the queue. They mail it in like everyone else. Only a registered courier with reserved agency access can genuinely speed things up.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}